import { Typography, message, Input, Row, Col, Button, Card, Space } from "antd";
import { useState, useEffect } from "react";
import ClientesIndex from "./ClientesIndex"; // Assume you have a component to display clients
import ClienteForm from "./ClienteForm";
import axios from "axios";
import { useAuth } from "../../layout/auth";
import PageTitle from "../../utils/PageTitle";
import PageWrapper from "../../utils/PageWrapper";
import { Plus, Users } from "lucide-react";

export default function Clients() {
  const [clientes, setClientes] = useState([]);
  const [cliente, setCliente] = useState(null);
  const [search, setSearch] = useState("");
  const [filteredClientes, setFilteredClientes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  const auth = useAuth();

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/clientes?u=${auth?.UID}`)
      .then((res) => {
        setClientes(res.data);
        setFilteredClientes(res.data); // Initialize filtered clients
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.message);
      });
  }, []);

  useEffect(() => {
    if (search) {
      const filtered = clientes.filter((cliente) => {
        return (
          cliente?.NombreCliente?.toLowerCase().includes(search.toLowerCase()) ||
          cliente?.Email?.toLowerCase().includes(search.toLowerCase()) ||
          cliente?.Telefono?.toLowerCase().includes(search.toLowerCase())
        );
      });
      setFilteredClientes(filtered);
    } else {
      setFilteredClientes(clientes);
    }
  }, [search, clientes]);

  return (
    <PageWrapper className="clientes-main-card">
      <PageTitle icon={<Users />} title="Clientes" />
      <div
        style={{
          padding: "16px",
          background: "rgba(249, 250, 251, 0.8)",
          borderRadius: "12px",
          border: "1px solid rgba(229, 231, 235, 0.6)",
          boxShadow: "0 4px 16px rgba(0, 0, 0, 0.05)",
          marginBottom: "24px",
        }}
      >
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Input.Search
              placeholder="Buscar clientes"
              onSearch={(value) => setSearch(value)}
              enterButton="Buscar"
              loading={loading}
              size="large"
              allowClear
              onChange={(e) => setSearch(e.target.value)}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ textAlign: "right" }}>
            <Space>
              <Button
                type="primary"
                icon={<Plus size={18} strokeWidth={1.5} />} 
                size="large"
                onClick={() => {
                  setVisible(true);
                  setCliente(null);
                }}
                style={{
                  borderRadius: "8px",
                  height: "40px",
                }}
              >
                Agregar
              </Button>
            </Space>
          </Col>
        </Row>
      </div>
      <ClientesIndex
        clientes={filteredClientes}
        loading={loading}
        setVisible={setVisible}
        setCliente={setCliente}
      />
      <ClienteForm clientes={clientes} setClientes={setClientes} visible={visible} setVisible={setVisible} cliente={cliente} />
    </PageWrapper>
  );
}
